import { CoreFormFieldTime } from '../fields/CoreFormFieldTime';
import type { ContextFormFieldBaseProps } from './ContextFormFieldBaseProps';
import type { FormFieldControllerRulesProps } from './FormFieldController';
import { FormFieldController } from './FormFieldController';

export const ContextFormFieldTime = ({
  fieldPath,
  rules,
  disabled,
  label,
  inline,
  placeholder,
  helperText,
}: Omit<ContextFormFieldBaseProps, 'label'> & { label?: string }) => {
  return (
    <FormFieldController
      name={fieldPath}
      rules={rules as FormFieldControllerRulesProps}
    >
      {({ field, fieldState }) => (
        <CoreFormFieldTime
          label={label && rules?.required ? `${label} *` : label}
          error={fieldState.error?.message?.toString()}
          inputProps={{
            id: fieldPath,
            ...field,
            disabled,
            placeholder,
          }}
          inline={inline}
          helperText={helperText}
        />
      )}
    </FormFieldController>
  );
};
